"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFindUsers = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useFindUsers() {
    return (0, core_ui_1.useApiGet)('users');
}
exports.useFindUsers = useFindUsers;
//# sourceMappingURL=useFindUsers.js.map